const Logo = ({ className = "h-10" }) => (
  <img
    data-testid="brand-logo"
    src="/assets/logo.png"
    alt="ECOCORE DX Ecografía y Diagnóstico"
    className={`w-auto object-contain ${className}`}
  />
);

export default Logo;
